"use client";

import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { useDashboardData } from "../../../../hooks/useDashboardData"; // Adjust path as needed

const TotalSales = () => {
  const [Chart, setChart] = useState();
  const [timeRange, setTimeRange] = useState("monthly");
  const { productivityTrend, setTimeRange: updateTimeRange } = useDashboardData();

  useEffect(() => {
    import("react-apexcharts").then((mod) => {
      setChart(() => mod.default);
    });
  }, []);

  // Prepare chart data based on productivity trend
 const getChartData = () => {
    if (!productivityTrend) {
      // Fallback data when no trend data is available
      if (timeRange === 'weekly') {
        return {
          series: [
            { name: "Current Period", data: [72, 75, 78, 80, 82, 79, 70] },
            { name: "Previous Period", data: [0, 0, 0, 0, 0, 0, 0] },
          ],
          categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        };
      } else if (timeRange === 'monthly') {
        return {
          series: [
            { name: "Current Period", data: [72, 75, 78, 80, 82, 85, 88, 90, 85, 82, 78, 75] },
            { name: "Previous Period", data: [68, 70, 72, 75, 78, 80, 82, 85, 82, 78, 73, 70] },
          ],
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        };
      } else {
        const currentYear = new Date().getFullYear();
        return {
          series: [
            { name: "Current Period", data: [78, 82, 85] },
            { name: "Previous Period", data: [0, 78, 82] },
          ],
          categories: [(currentYear-2).toString(), (currentYear-1).toString(), currentYear.toString()],
        };
      }
    }

    return {
      series: [
        {
          name: "Current Period",
          data: productivityTrend.currentPeriod || [],
        },
        {
          name: "Previous Period",
          data: productivityTrend.previousPeriod || [],
        },
      ],
      categories: productivityTrend.categories || [],
    };
  };

  const chartData = getChartData();
  const categories = chartData.categories;

  const options = {
    chart: {
      zoom: {
        enabled: false,
      },
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40%",
        borderRadius: 4,
      },
    },
    colors: ["#605DFF", "#DDE4FF"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: [2, 2, 0],
      dashArray: [0, 6, 0], // Dashed line for previous period
    },
    grid: {
      show: false,
      borderColor: "#ECEEF2",
    },
    fill: {
      type: "gradient",
      gradient: {
        stops: [0, 90, 100],
        shadeIntensity: 1,
        opacityFrom: 0,
        opacityTo: 0.5,
      },
    },
    xaxis: {
      categories: categories,
      axisTicks: {
        show: false,
        color: "#ECEEF2",
      },
      axisBorder: {
        show: false,
        color: "#ECEEF2",
      },
      labels: {
        show: true,
        style: {
          colors: "#8695AA",
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      tickAmount: 5,
      max: 100,
      min: 0,
      labels: {
        formatter: (val) => {
          return val + "%"; // Changed from "$" + val + "K" to val + "%"
        },
        style: {
          colors: "#64748B",
          fontSize: "12px",
        },
      },
      axisBorder: {
        show: false,
        color: "#ECEEF2",
      },
      axisTicks: {
        show: false,
        color: "#ECEEF2",
      },
    },
    legend: {
      show: true,
      position: "top",
      fontSize: "12px",
      horizontalAlign: "left",
      itemMargin: {
        horizontal: 8,
        vertical: 0,
      },
      labels: {
        colors: "#64748B",
      },
      markers: {
        shape: 'diamond',
        radius: 2,
        offsetX: -2,
        offsetY: -0.5,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + "%"; // Changed from "$" + val + "k" to val + "%"
        },
      },
    },
  };

  const handleTimeRangeChange = (e) => {
    const newRange = e.target.value;
    setTimeRange(newRange);
    updateTimeRange(newRange);
  };

  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-center gap-3 mb-3 mb-lg-30">
            <h3 className="mb-0">Productivity Trend</h3>
            <Form.Select
  className="form-select"
  aria-label="Time range select"
  value={timeRange}
  onChange={handleTimeRangeChange}
  style={{
    width: "auto",
    minWidth: "120px",
    display: "inline-block"
  }}
>
  <option value="weekly">Weekly</option>
  <option value="monthly">Monthly</option>
  <option value="yearly">Yearly</option>
</Form.Select>
          </div>

          <div
            style={{
              marginBottom: "-15px",
              marginLeft: "-10px",
              marginTop: "-5px",
            }}
          >
            {Chart && chartData.series[0].data.length > 0 && (
              <Chart
                options={options}
                series={chartData.series}
                type="area"
                height={363}
              />
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default TotalSales;